import apiClient from '@/api/client';
import { AuditLog } from './PartnerAuditLogService';
import { SimProviderLookup } from '@/models/simProviderLookup';
import { ConfigurationLookup } from '@/models/configurationLookup';

export const AuditLogService = {
    async getAll(): Promise<GetAllAuditLogsResponse> {
        const response = await apiClient.get<GetAllAuditLogsResponse>('/audit-logs');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve platform audit logs.');
        }

        return result;
      }
}


export interface GetAllAuditLogsResponse {
    logs: AuditLog[],
    lookups: AuditLogLookupsResponse
}

export interface AuditLogLookupsResponse {
    simProviders: SimProviderLookup[],
    configurations: ConfigurationLookup[]
}